// src/components/store/sections/faqs/FaqV56ClaytogglesRoyalViolet.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV56ClaytogglesRoyalViolet(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={56}
      archKey="clay_toggles"
      archLabel="3D Claymorphic Toggles"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
